<script>
    import jQuery from "jquery";
    import {overwriteOnlineName} from "./gp";
    import {getGPTransFunc} from "./gp-translations";

    let email;
    $: message = trans("Hi,\n\nHere is the garden design I want to share with you. \n\nBest regards,\n");
    export let project;
    $: projectid = $overwriteOnlineName ? project.savedId : project.savedId;
    let sendInProgress = false;
    /**
     * @type {"sharing"|"notsaved"}
     */
    $: mode = projectid ? "sharing" : "notsaved";

    $: validEmail = !email || email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    $: valid = validEmail && message && message.length > 0;

    let trans = getGPTransFunc("gp-share-by-email");

    export async function showForm() {
        jQuery('#sendByEmailForm').modal();
        jQuery('#sendByEmailForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#sendByEmailForm').on('shown.bs.modal',function () {
            let el = document.getElementById('sendByEmailFormEmail');
            if (el) el.focus()
        });
    }

    function send() {
        if (!email || !valid || sendInProgress) return;
        sendInProgress = true;

        GPSettings.storageClass.shareByEmail(email, message, projectid).then(sent);
    }

    function sent() {
        jQuery('#sendByEmailForm').modal('hide');
    }

    function save() {
        let evt = new CustomEvent('showOnlineSaveModal', {});
        window.dispatchEvent(evt);
    }

</script>

<div id="sendByEmailForm" class="modal fade GPModal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{trans("Send by email")}</h4>
      </div>
      <div class="modal-body sendByEmailFormEmail">
          {#if mode === "sharing"}
            <div class="form-group">
                <label for="sendByEmailFormEmail">{trans("Recipient email")}:</label>
                <input class="form-control" id="sendByEmailFormEmail" type="email" bind:value={email}/>
            </div>
            <div class="form-group sendByEmailFormMessage">
                <label for="sendByEmailFormMessage">{trans("Message")}:</label>
                <textarea class="form-control" id="sendByEmailFormMessage" rows="8" bind:value={message}></textarea>
            </div>
              <div class="form-group">
                <button on:click={send} type="button" class="btn btn-default" class:disabled={!email || !valid || sendInProgress}>{trans("Send")}
                    {#if sendInProgress}<i class="button-waiting fa fa-spin fa-spinner" style="display: inline-block"></i>{/if}
                </button>
            </div>
          {:else}
              <p>{trans("Sharing is possible only for projects that have been saved online.")}
                  <a href="#" on:click={save}>{trans("Save the project first.")}</a></p>
          {/if}
      </div>
      <div class="modal-footer">
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->